import { type ReactNode } from "react";
import { Stack, Box, useTheme, useMediaQuery } from "@mui/material";

import { SideIllustration } from "@app/components";

import { StyledContent } from "./styles";

// --------------------------------------------------------------

interface Props {
  children: ReactNode;
  title: string;
}

const AuthLayout = ({ children }: Props) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack
      direction="row"
      flex={1}
      height={isLargeScreen ? "100vh" : "auto"}
      position="relative"
      sx={{
        overflowY: isLargeScreen ? "hidden" : "auto",
      }}
    >
      {isLargeScreen && (
        <Box width="50%">
          <SideIllustration />
        </Box>
      )}
      <StyledContent
        sx={{
          minHeight: isLargeScreen ? "auto" : "100vh",
          overflowY: isLargeScreen ? "auto" : "auto",
        }}
      >
        {children}
      </StyledContent>
    </Stack>
  );
};

export { AuthLayout };
